<a class="img">
    @if (item().cardImage; as cardImage) {
    <img [ngSrc]="cardImage.src" width="256" height="256" placeholder [attr.alt]="cardImage.alt" />
    }
</a>
<div class="content">
    <!-- <div class="post-meta">
      <span>{{item().date | date:'dd MMM yyyy'}}</span>
      <span>{{item().tags}}</span>
    </div> -->
    @if (item().url?.trim().length > 0) {
    <a routerLink="{{ item().url }}">
        <h4 class="blog-title">{{ item().title }}</h4>
        <h5 style="line-height: 1.5em; font-size: 16px; margin-bottom: 0.75em; color: var(--accent)">{{ item().author }}</h5>
    </a>
    } @else {
    <a class="blog-title" href="javascript:;">{{ item().title }}</a>
    } @if (item().description?.trim().length) {
    <div class="desc">{{ item().description }}</div>
    } @if (item().showMoreBtn) {
    <a style="align-self: flex-end" routerLink="{{ item().url }}" i18n>More</a>
    }
</div>
